<template>
  <div>
<!--    <a @click="$bus.$emit('orders-edit-order', row)">-->
<!--      <mdb-icon icon="edit"/>-->
<!--    </a>-->
    <router-link :to="`order/${row.info.uuid}`">
      <mdb-icon icon="edit"/>
    </router-link>
  </div>
</template>

<script>
import { mdbIcon } from 'mdbvue'

export default {
  name: 'OrdersTableCellEdit',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  components: { mdbIcon }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersTableCellEdit.vue